import { useInfoCard } from '../hooks/useInfoCard';
import { VtexButton } from '../../../styleguide/VtexButton';
import { CallToActionModeEnum } from '../@types/InfoCardProps';

interface ActionWrapperProps {
	mode?: CallToActionModeEnum;
	text?: string;
}

const noop = () => undefined;

export function InfoCardCallActionContainer(): JSX.Element | null {
	const { callToActionText, callToActionUrl, callToActionMode, handles } = useInfoCard();

	if (callToActionMode === 'none' || !callToActionText) {
		return null;
	}

	const ActionWrapper = ({ text, mode }: ActionWrapperProps) => {
		if (mode === 'button') {
			return <VtexButton handleClick={noop}>{text}</VtexButton>;
		}

		// Mode is link
		return <p className={`${handles.infoCardCallActionText} link t-body b underline c-action-primary`}>{text}</p>;
	};

	return (
		<a target="_self" className={`${handles.infoCardCallActionContainer} mt6 mb6`} href={callToActionUrl}>
			<ActionWrapper text={callToActionText} mode={callToActionMode} />
		</a>
	);
}
